import { Injectable, inject } from "@angular/core";
import { BehaviorSubject, forkJoin, Observable, of } from "rxjs";
import { first } from "rxjs/operators";
import { TourService } from "ngx-ui-tour-md-menu";
import { LorenUtilsService } from "../loren-utils-service/loren-utils.service";
import { LorenFeatureToggleService } from "../loren-feature-toggle-service/loren-feature-toggle.service";
import { LorenTourStep } from "../../interfaces/loren-tour-step.interface";
import {
  LorenAutomationPlanTourSteps,
  LorenSidenavTourSteps,
} from "../../constants/loren-tour-steps.constants";

@Injectable({
  providedIn: "root",
})
export class LorenTourService {
  private tourService = inject(TourService);
  private featureToggleService = inject(LorenFeatureToggleService);

  private tourRunning: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  getTourRunningCurrentState(): boolean {
    return this.tourRunning.getValue();
  }

  getTourRunning$(): Observable<boolean> {
    return this.tourRunning.asObservable();
  }

  updateTourRunningState(state: boolean) {
    this.tourRunning.next(state);
  }

  triggerCommonApplicationTour() {
    const allSteps = Object.assign([], LorenSidenavTourSteps);
    const featuresObservable: Observable<boolean>[] = [];

    allSteps.forEach((x) => {
      if (!x.featureName) {
        featuresObservable.push(of(true));
        return;
      }

      const s = this.featureToggleService.userHasFeature(x.featureName);
      featuresObservable.push(s);
    });

    // TODO refactor this
    forkJoin(featuresObservable)
      .pipe(first())
      .subscribe((res) => {
        const enabledTourStepsBasedOnFeatureToggle: LorenTourStep[] = res
          .filter((x) => x)
          .map((x, index) => allSteps[index]);

        this.tourService.initialize(enabledTourStepsBasedOnFeatureToggle);
        this.tourService.start();
        this.updateTourRunningState(true);
        LorenUtilsService.updateLastUserTour();
      });
  }

  triggerAutomationPlanTour() {
    const allSteps = Object.assign([], LorenAutomationPlanTourSteps);
    this.tourService.initialize(allSteps);
    this.tourService.start();
    this.updateTourRunningState(true);
  }
}
